const estimate = {
  state: () => ({
    estimateStoreInfo: {}, //门店信息
    revenueSaleForecastMeal: {}, //餐段预估数据
    revenueSaleForecastChannel: {}, //渠道预估数据
    revenueRule: {}, //营收和菜品营收规则
    revenueDateInfo: {}, //营收信息
    revenueList: {}, //菜品营收信息
    calendarDate: null, //日历选中的日期
    dishRevenueRateData: {}, //菜品营收见台率/万元销量
    dishRevenueRateDataTabSave: {
      stationWork: [],
      stationRest: [],
      festival: [],
      leave: [],
    }, //菜品营收见台率/万元销量，tab切换保存
  }),
  mutations: {
    SET_ESTIMATE_STATE(state, payload) {
      const { key, value } = payload
      state[key] = value
    },
  },
  getters: {
    getEstimateStoreInfo(state) {
      return state.estimateStoreInfo
    },
    getSaleForecastMeal(state) {
      return state.revenueSaleForecastMeal
    },
    getSaleForecastChannel(state) {
      return state.revenueSaleForecastChannel
    },
    getRevenueRule(state) {
      return state.revenueRule
    },
    getRevenueDateInfo(state) {
      return JSON.stringify(state.revenueDateInfo) == '{}' ? null : state.revenueDateInfo
    },
    getRevenueList(state) {
      return JSON.stringify(state.revenueList) == '{}' ? null : state.revenueList
    },
    getCalendarDate(state) {
      return state.calendarDate
    },
    getDishRevenueRateData(state) {
      return JSON.stringify(state.dishRevenueRateData) == '{}' ? null : state.dishRevenueRateData
    },
    getDishRevenueRateDataTabSave(state) {
      return JSON.stringify(state.dishRevenueRateDataTabSave) == '{}' ? null : state.dishRevenueRateDataTabSave
    },
  },
  actions: {},
}

export default estimate
